import { useEffect, useRef, useState, useMemo } from 'react';
import { Box } from '@mui/material';
import { FaTerminal } from 'react-icons/fa';
import { ETL_COPILOT } from '../copilot-constant/Images';
import './LogsTerminal.css';

function LogsTerminal({ logs = [], withAvatar = false, showAvatar, showBlink }) {
  const terminalRef = useRef(null);
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);

  // Detect scroll position
  useEffect(() => {
    const el = terminalRef.current;
    if (!el) return;

    const handleScroll = () => {
      const isAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 10; // 10px tolerance
      setShouldAutoScroll(isAtBottom);
    };

    el.addEventListener('scroll', handleScroll);
    return () => el.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to bottom if enabled
  useEffect(() => {
    if (terminalRef.current && shouldAutoScroll) {
      terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    }
  }, [logs, shouldAutoScroll]);

  const { filteredLogs, showBlinkingDot } = useMemo(() => {
    const result = [];
    let lastUnique = null;
    let showDot = false;

    for (let i = 0; i < logs.length; i++) {
      const current = logs[i];

      if (current !== lastUnique) {
        result.push(current);
        lastUnique = current;
        showDot = false;
      } else if (i === logs.length - 1) {
        showDot = true;
      }
    }

    return { filteredLogs: result, showBlinkingDot: showDot };
  }, [logs]);

  return (
    <Box
      sx={{
        pl: withAvatar && !showAvatar ? '65px' : 0,
        display: 'flex',
        flexDirection: 'row',
        my: 2,
      }}
    >
      {withAvatar && showAvatar && (
        <Box sx={{ width: 40, height: 40, mx: 1.5 }}>
          <img
            src={ETL_COPILOT.LOGO}
            alt="Copilot"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              borderRadius: '50%',
            }}
          />
        </Box>
      )}

      <div
        className="terminal"
        style={{
          minWidth: withAvatar ? '25%' : '85%',
          maxWidth: withAvatar ? '75%' : '85%',
          minHeight: '10vh',
          maxHeight: '70vh',
        }}
      >
        <div className="terminal-header" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <FaTerminal size={14} style={{ color: '#888' }} />
          <span className="command">etl-copilot terminal</span>
        </div>

        <div className="terminal-body" ref={terminalRef}>
          {filteredLogs.map((log, i) => (
            <div key={i} className={`log-line-${log}`}>
              {log}
              {showBlinkingDot && filteredLogs.length - 1 === i && <span className="blinking-dot" />}
            </div>
          ))}
        </div>
      </div>
    </Box>
  );
}

export default LogsTerminal;
